import {
  IconButton,
  TextInput,
  ColoredNextIcon as coloredNextIcon,
  ColoredPreviousIcon as coloredPreviousIcon,
  NextIcon as nextIcon,
  PreviousIcon as previousIcon,
} from '@/shared/ui';
import useAfibPaginationContainer from './useAfibPaginationContainer';

export type AfibPaginationContainerProps = {
  activeButton: any;
  isDisabled?: boolean;
};

/**
 * Page controls for the AFib event strip list. Renders previous and next buttons plus a numeric page input showing the max page count, all suppressed when the hook reports pagination is unnecessary and disabled while the list is loading.
 *
 * @param props - The pagination props, including isDisabled which blocks the controls while strips load.
 * @returns The rendered pagination controls, or an empty container when pagination is not needed.
 */
const AfibPaginationContainer = ({ activeButton, isDisabled }: AfibPaginationContainerProps) => {
  const {
    isShowPagination,
    isDisabledPrev,
    isDisabledNext,
    onClickPrevious,
    onClickNext,
    maxPageNumber,
    pageString,
    onChangePageString,
    onKeyDown,
    onBlur,
    inputSize,
    isError,
  } = useAfibPaginationContainer({ activeButton, isDisabled });

  return (
    <div className="pagination-container">
      {isShowPagination && (
        <>
          <IconButton
            id="afib-events-previous-page-btn"
            isFilled
            disabled={isDisabledPrev || isDisabled}
            iconComponent={
              <img src={isDisabledPrev ? previousIcon : coloredPreviousIcon} alt="Previous icon" />
            }
            onClick={onClickPrevious}
          />
          <TextInput
            id="afib-events-page-input"
            ariaLabel="Page number"
            suffix={`/ ${maxPageNumber}`}
            name="pageString"
            value={pageString}
            onChange={onChangePageString}
            onKeyDown={onKeyDown}
            onBlur={onBlur}
            isNumberFormat
            shouldChangeSize
            className="page-input"
            size={inputSize}
            isError={isError}
            disabled={isDisabled}
            decimalSeparator={false}
          />
          <IconButton
            id="afib-events-next-page-btn"
            isFilled
            disabled={isDisabledNext || isDisabled}
            iconComponent={
              <img src={isDisabledNext ? nextIcon : coloredNextIcon} alt="Next icon" />
            }
            onClick={onClickNext}
          />
        </>
      )}
    </div>
  );
};

export default AfibPaginationContainer;
